module.exports = __webpack_public_path__ + "img/task.0b2ad49b.webp";